import { useMemo } from "react";

import BrandCard from "./BrandCard";
import useBrandsOfUser from "../../../../../../clients/users/useBrandsOfUser";
import { useFinder } from "../../../../../../modules/finder";
import { useBrands } from "../../../../../../modules/shared-entities";

export default function BrandFinderPlugin(props) {
    const { Component = BrandCard, onSelect } = props;

    const brands = useBrands().data?.brands ?? [];

    const { token } = useFinder();

    const userBrands = useBrandsOfUser();

    const filteredBrands = useMemo(
        () => brands
            .filter(
                (brand) => [
                    brand.id.toLowerCase() === token.toLowerCase(),
                    brand.legacyID === token,
                    brand.legacyAlias?.toLowerCase?.()?.includes?.(token.toLowerCase()),
                    brand.name.toLowerCase().includes(token.toLowerCase()),
                ].some(Boolean)
            )
            .filter(
                (brand) => userBrands.includes("*") || userBrands.includes(brand.id)
            )
            .sort(
                (a, b) => a.name.localeCompare(b.name),
            ),
        [brands, token, userBrands],
    );


    return filteredBrands.map(
        (brand) => (
            <Component
                key={ brand.id }
                name={ brand.name }
                onClick={ () => onSelect(brand) }
            />
        )
    );
}
